const state = () => ({
  isValid: false,
  personalDataAgreement: false,
  newsletterAgreement: false
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  personalDataAgreement(state) {
    return state.personalDataAgreement;
  },
  newsletterAgreement(state) {
    return state.newsletterAgreement;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updatePersonalDataAgreement(state, payload) {
    state.personalDataAgreement = payload;
  },
  updateNewsletterAgreement(state, payload) {
    state.newsletterAgreement = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

export const hrbAgreements = {
  state,
  getters,
  mutations,
  namespaced: true
};
